import { wrapPageElement as wpe } from './src/components/gatsby-wrapper/gatsby-wrapper'
import './src/utils/modernizr.min.js'

export const wrapPageElement = wpe